import { state } from "@src/state";
export const selectStudioSavedState = () => state.meeting.studio.savedState;
